import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_WITHDRAWALS_HISTORY_ROUTE_NAME,
  WITHDRAWALS_HISTORY_PERMISSIONS,
} from '@modules/withdrawals-history/constants';

import { ADMIN_WITHDRAWALS_HISTORY_VIEW_ROUTE_NAME } from './constants';

export class WithdrawalsHistoryViewModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_WITHDRAWALS_HISTORY_ROUTE_NAME, {
      name: ADMIN_WITHDRAWALS_HISTORY_VIEW_ROUTE_NAME,
      path: 'view/:id',
      component: () => import('./pages/WithdrawalsHistoryViewPage/WithdrawalsHistoryViewPage.vue'),
      permission: WITHDRAWALS_HISTORY_PERMISSIONS.SHOW,
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
